// Central build version — used by the cache buster AND the service worker.
// Bump this on every deploy to force fresh assets for all users.
// 4-Tier versioning policy: bump per the CHANGELOG rules.
export const APP_BUILD_VERSION = "0.0.0.27";

// Cache version derived from the app version — changing this invalidates
// the service worker cache and the Insights post cache on every deploy.
export const CACHE_VERSION = `ticca-cache-${APP_BUILD_VERSION}`;
